import React from 'react'
import ReactPlayer from 'react-player'

export const Video = ({ ID, playing=false }) => (
    <ReactPlayer url={ID} controls playing={playing} width="100%" height="100%" />
)
